import { Link } from "react-router-dom";

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
      <div className="grid grid-cols-1 items-center gap-8 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 md:grid-cols-2 md:p-10">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-information-line" />
            关于噜噜社
          </span>
          <h2 className="mt-4 text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
            做一个懂娱乐、也懂潮流的资讯站
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            噜噜社专注音乐、影视、时尚与潮流文化四大板块，用及时的资讯流、结构化的分类和深度专题，帮你在信息过载的时代里快速找到真正值得读的内容。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4">
            <div>
              <p className="text-2xl font-extrabold text-primary-500">4</p>
              <p className="mt-1 text-xs text-foreground-500">核心内容板块</p>
            </div>
            <div>
              <p className="text-2xl font-extrabold text-primary-500">14+</p>
              <p className="mt-1 text-xs text-foreground-500">持续更新资讯</p>
            </div>
            <div>
              <p className="text-2xl font-extrabold text-primary-500">每日</p>
              <p className="mt-1 text-xs text-foreground-500">内容更新频率</p>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="mailto:hello@lulushe.com"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-mail-line" />
              hello@lulushe.com
            </a>
          </div>
        </div>
        <div className="h-64 w-full overflow-hidden rounded-lg bg-background-200 md:h-80">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20creative%20editorial%20workspace%20with%20magazines%20vinyl%20records%20and%20a%20camera%20arranged%20on%20a%20warm%20wooden%20desk%2C%20soft%20natural%20light%2C%20warm%20orange%20and%20cream%20palette%2C%20grainy%20texture%2C%20minimal%20composition&width=1200&height=900&seq=lulu-about-hero&orientation=landscape"
            alt="噜噜社编辑部工作场景"
            title="噜噜社编辑部 - 综合娱乐资讯与潮流文化平台"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}